import React from 'react';

export function SvgDefsRoot() {
  return (
    <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden>
      <defs>
        {/* Elite Line Chart Gradients */}
        <linearGradient id="eliteLineGradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#00d4ff" stopOpacity={1} />
          <stop offset="25%" stopColor="#06b6d4" stopOpacity={0.9} />
          <stop offset="50%" stopColor="var(--tyler-blue)" stopOpacity={0.8} />
          <stop offset="75%" stopColor="#a855f7" stopOpacity={0.7} />
          <stop offset="100%" stopColor="#10b981" stopOpacity={0.6} />
        </linearGradient>
        
        <radialGradient id="eliteLineRadial" cx="30%" cy="30%" r="70%">
          <stop offset="0%" stopColor="#ffffff" stopOpacity={0.8} />
          <stop offset="40%" stopColor="var(--tyler-blue)" stopOpacity={0.6} />
          <stop offset="100%" stopColor="#1e293b" stopOpacity={0.4} />
        </radialGradient>

        {/* Elite Area Chart Gradients */}
        <linearGradient id="eliteAreaGradient" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#00d4ff" stopOpacity={0.95} />
          <stop offset="12%" stopColor="#06b6d4" stopOpacity={0.85} />
          <stop offset="24%" stopColor="var(--tyler-blue)" stopOpacity={0.75} />
          <stop offset="36%" stopColor="#a855f7" stopOpacity={0.65} />
          <stop offset="48%" stopColor="#10b981" stopOpacity={0.55} />
          <stop offset="60%" stopColor="#f59e0b" stopOpacity={0.45} />
          <stop offset="72%" stopColor="#ef4444" stopOpacity={0.35} />
          <stop offset="84%" stopColor="var(--tyler-blue)" stopOpacity={0.25} />
          <stop offset="96%" stopColor="#1e293b" stopOpacity={0.15} />
          <stop offset="100%" stopColor="#020617" stopOpacity={0.05} />
        </linearGradient>

        {/* Elite Bar Chart Gradients */}
        <linearGradient id="eliteBarGradient1" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#00d4ff" stopOpacity={1} />
          <stop offset="25%" stopColor="#06b6d4" stopOpacity={0.9} />
          <stop offset="50%" stopColor="var(--tyler-blue)" stopOpacity={0.8} />
          <stop offset="75%" stopColor="#4c1d95" stopOpacity={0.7} />
          <stop offset="100%" stopColor="#1e293b" stopOpacity={0.6} />
        </linearGradient>

        {/* 3D Depth Filters */}
        <filter id="elite3D" x="-100%" y="-100%" width="300%" height="300%">
          <feOffset in="SourceGraphic" dx="3" dy="6" result="offset1"/>
          <feGaussianBlur in="offset1" stdDeviation="8" result="blur1"/>
          <feFlood floodColor="#000000" floodOpacity="0.7"/>
          <feComposite in2="blur1" operator="in" result="shadow1"/>
          
          <feOffset in="SourceGraphic" dx="1" dy="3" result="offset2"/>
          <feGaussianBlur in="offset2" stdDeviation="4" result="blur2"/>
          <feFlood floodColor="#1e293b" floodOpacity="0.5"/>
          <feComposite in2="blur2" operator="in" result="shadow2"/>
          
          <feGaussianBlur in="SourceAlpha" stdDeviation="1" result="innerGlow"/>
          <feOffset dx="0" dy="0" result="innerOffset"/>
          <feFlood floodColor="#ffffff" floodOpacity="0.3"/>
          <feComposite in2="innerGlow" operator="in" result="glow"/>
          
          <feMerge>
            <feMergeNode in="shadow1"/>
            <feMergeNode in="shadow2"/>
            <feMergeNode in="glow"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>

        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
          <feMerge> 
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>

        <filter id="eliteArea3D" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="4" stdDeviation="6" floodColor="#000" floodOpacity="0.5"/>
          <feDropShadow dx="0" dy="2" stdDeviation="3" floodColor="var(--tyler-blue)" floodOpacity="0.3"/>
        </filter>

        <filter id="eliteAreaGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge> 
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
    </svg>
  );
}
